module.exports = __webpack_public_path__ + "img/yellow-lines.05707a83.svg";